import React, { Component } from "react";
import { Field } from "formik";
import "./Marketing.scss";
import CustomIntlTelInput from "./CustomIntlTelInput";
import { currentLocale } from "../locale";
import { Checkbox } from "./Checkbox";
import ContactInfoFields from "./ContactInfoFields";

class Marketing extends Component {
  state = {
    stateParticipantData: {
      phoneNumber: "", //+447795214092
      email: "",
      icePhoneNumber: "",
      role: 1, //isParticipant - already entered (its own tab)
      optIn: true, //must be true in order to end up on this page
      messagingOptIn: true,
    },
  };

  render() {
    const { values, errors, touched, waiver } = this.props;

    let preferredCountries = ["us", "gb", "ca"];
    const locale = window.navigator.language;
    if (locale && locale.length === 5) {
      const country = locale.substring(3).toLowerCase();
      if (preferredCountries.indexOf(country) === -1) {
        preferredCountries.unshift(country);
      }
    }

    const hasContactInfo =
      waiver.getPhone || waiver.getEmail || waiver.getAddress;

    const getIceNumber = () => {
      return (
        <div className="field">
          <label className="label">{currentLocale.enterIce}:</label>
          <Field
            name="icePhoneNumber"
            validate={(phoneNumber) =>
              window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                ? ""
                : `${currentLocale.phoneNumberError}`
            }
            value={values.icePhoneNumber}
            component={CustomIntlTelInput}
            preferredCountries={preferredCountries}
            css="input"
          />
        </div>
      );
    };

    return (
      <div className="collect-marketing-information">
        {hasContactInfo ? (
          <div>
            <ContactInfoFields
              waiver={waiver}
              errors={errors}
              touched={touched}
              values={values}
              preferredCountries={preferredCountries}
            />

            {waiver.iceNumber && getIceNumber()}
            <div>
              <Field
                className="checkbox"
                component={Checkbox}
                name="optIn"
                label={currentLocale.optInHeading}
                value={values.optIn}
              />
            </div>
          </div>
        ) : waiver.iceNumber ? (
          <div>{getIceNumber()}</div>
        ) : (
          <div>
            <h1>{currentLocale.loading}</h1>
          </div>
        )}
      </div>
    );
  }
}

export default Marketing;
